import './AboutPage.css'
import { useEffect, useRef, useState } from 'react'
import websiteData from '../../data/websiteData'

const { valueProps } = websiteData

export default function About() {
    const sectionRef = useRef(null)
    const [progress, setProgress] = useState(0)
    const [openCards, setOpenCards] = useState(new Set())

    useEffect(() => {
        const onScroll = () => {
            const el = sectionRef.current
            if (!el) return
            setProgress(Math.min(Math.max(-el.getBoundingClientRect().top / (el.getBoundingClientRect().height - window.innerHeight), 0), 1))
        }
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    const titlePhase = Math.min(progress / 0.3, 1)
    const cardsPhase = Math.max((progress - 0.25) / 0.2, 0)

    const toggle = (i) => setOpenCards(prev => {
        const next = new Set(prev)
        next.has(i) ? next.delete(i) : next.add(i)
        return next
    })

    return (
        <div className="about-scroll-track" ref={sectionRef}>
            <div className="about-sticky">
                <div
                    className="about-inner"
                    style={{ transform: `translateY(${(1 - titlePhase) * 35}vh)` }}
                >
                    <div
                        className="about-title-wrap"
                        style={{
                            transform: `scale(${1 - titlePhase * 0.38})`,
                            opacity: 1,
                            transformOrigin: 'top center',
                        }}
                    >
                        <span className="about-eyebrow">Why Vedra?</span>
                        <h1 className="about-title">{valueProps.title}</h1>
                    </div>

                    <div
                        className="about-cards"
                        style={{
                            opacity: cardsPhase,
                            transform: `translateY(${(1 - cardsPhase) * 24}px)`,
                        }}
                    >
                        {valueProps.sections.map((section, i) => {
                            const isOpen = openCards.has(i)
                            const hasItems = section.items?.length > 0
                            const hasContent = hasItems || section.description

                            return (
                                <div
                                    key={i}
                                    className={`about-card${isOpen ? ' about-card--open' : ''}${hasContent ? ' about-card--expandable' : ''}`}
                                    onClick={() => hasContent && toggle(i)}
                                >
                                    <div className="about-card-header">
                                        <span className="about-card-number">0{i + 1}</span>
                                        <h3 className="about-card-title">{section.title}</h3>
                                        {hasContent && (
                                            <span className="about-card-chevron" aria-hidden="true">
                        {isOpen ? '−' : '+'}
                    </span>
                                        )}
                                    </div>

                                    {hasContent && (
                                        <div className="about-card-body">
                                            <div>
                                                {hasItems
                                                    ? section.items.map((item, j) => (
                                                        <div key={j} className="about-card-item">
                                                            <p className="about-card-item-title">{item.title}</p>
                                                            <p className="about-card-item-desc">{item.description}</p>
                                                        </div>
                                                    ))
                                                    : (
                                                        <div className="about-card-item">
                                                            {section.subtitle && (
                                                                <p className="about-card-item-title">{section.subtitle}</p>
                                                            )}
                                                            {section.description && (
                                                                <p className="about-card-item-desc">{section.description}</p>
                                                            )}
                                                            {section.extra?.syntheticPooling && (
                                                                <p className="about-card-item-desc">{section.extra.syntheticPooling}</p>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}